const ErrorPage = (): JSX.Element => {
  return (<>
    <h1>An error has occured.</h1>
    <p>Please reload this page or try again later.</p>
  </>)
}

export default ErrorPage
